import { firebase as fiff } from 'mostra';
// import * as firebase from 'firebase/app';
// import 'firebase/firestore';
// import 'firebase/functions';
// import 'firebase/auth';
// import 'firebase/storage';
// import retryPromise from '@/modules/retryPromise';

// console.log(process.env);
// console.log(process.env.GCP_API_KEY);

// import 'firebase/firestore';
// import 'firebase/functions';
// import 'firebase/auth';
// import 'firebase/storage';
export const init = () => {
  const config = {
    apiKey: process.env.VUE_APP_GCP_API_KEY,
    authDomain: process.env.VUE_APP_GCP_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_GCP_DATABASE_URL,
    projectId: process.env.VUE_APP_GCP_PROJECT_ID,
    storageBucket: process.env.VUE_APP_GCP_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_GCP_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_GCP_APP_ID,
  };

  fiff.init(config);
};

// import 'firebase/firestore';
// import 'firebase/functions';
// import 'firebase/auth';
// import 'firebase/storage';
// import retryPromise from '@/modules/retryPromise';
//
// console.log('init firebase');
// const config = {
//   apiKey: process.env.VUE_APP_GCP_API_KEY,
//   authDomain: process.env.VUE_APP_GCP_AUTH_DOMAIN,
//   databaseURL: process.env.VUE_APP_GCP_DATABASE_URL,
//   projectId: process.env.VUE_APP_GCP_PROJECT_ID,
//   storageBucket: process.env.VUE_APP_GCP_STORAGE_BUCKET,
//   messagingSenderId: process.env.VUE_APP_GCP_MESSAGING_SENDER_ID,
//   appId: process.env.VUE_APP_GCP_APP_ID,
// };
//
// const fi = firebase.initializeApp(config);
// fi.auth()
//   .setPersistence(firebase.auth.Auth.Persistence.LOCAL);
//
// export const db = firebase.firestore();
// // db.settings({ timestampsInSnapshots: true });
//
// export const storage = firebase.storage().ref();
//
// export const functions = (name: string, params: any) => {
//   const fiFunctions = firebase.functions('asia-northeast1');
//   if (process.env.VUE_APP_EMULATOR) {
//     console.log('User emulator of functions');
//     fiFunctions.useFunctionsEmulator('http://localhost:5101');
//   }
//
//   return retryPromise.then(() => fiFunctions.httpsCallable(name)(params));
// };

// export const auth = firebase.auth;
// export const auth = firebase.auth();
// export const now = () => firebase.firestore.FieldValue.serverTimestamp();
// export const EmailAuthProvider = firebase.auth.EmailAuthProvider;
